import { Injectable } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { LogoutSuccess } from 'gp-auth';
import { PermissionEnum, PROGRESS_STATUSES } from 'symbols';
import { AccessService } from '../access.service';
import { LoadUserRoles, LoadUserRolesFail, LoadUserRolesSuccess } from './access.actions';
import { AccessStateModel, DEFAULT_ACCESS_STATE } from './access.model';

@State<AccessStateModel>({
  name: 'access',
  defaults: DEFAULT_ACCESS_STATE
})
@Injectable()
export class AccessState {
  constructor(private accessService: AccessService) {
  }

  @Selector()
  static currentRoles(state: AccessStateModel): AccessStateModel['roles'] {
    return state.roles;
  }

  @Selector()
  static currentRolesDict(state: AccessStateModel): { [key: string]: PermissionEnum } {
    return state.roles.reduce((acc, role) => {
      acc[role] = role;
      return acc;
    }, {});
  }


  @Action(LoadUserRoles)
  loadUserAccess(ctx: StateContext<AccessStateModel>): void {
    ctx.patchState({
      loadRolesStatus: PROGRESS_STATUSES.IN_PROGRESS
    });

    this.accessService.getAccess().subscribe({
      next: userAccess => ctx.dispatch(new LoadUserRolesSuccess(userAccess)),
      error: error => ctx.dispatch(new LoadUserRolesFail(error))
    });
  }

  @Action(LoadUserRolesSuccess)
  loadUserAccessSuccess(ctx: StateContext<AccessStateModel>, { roles }: LoadUserRolesSuccess): void {

    ctx.patchState({
      loadRolesStatus: PROGRESS_STATUSES.SUCCESS,
      roles: roles.map((permission) => permission.name)
    });

  }

  @Action(LoadUserRolesFail)
  loadUserAccessFail(ctx: StateContext<AccessStateModel>, { error }: LoadUserRolesFail): void {
    ctx.patchState({
      loadRolesStatus: PROGRESS_STATUSES.FAIL,
      roles: []
    });
  }


  @Action(LogoutSuccess)
  logoutSuccess(ctx: StateContext<AccessStateModel>): void {
    ctx.patchState(DEFAULT_ACCESS_STATE);
  }

}
